// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS pour la page Profil unifiee (Accord Cadre + Prestataire Libre)
 * Design aligne avec le reste de l'application
 */

.profil-container {
  padding: 2rem;
  background: #fafafa;
  min-height: 100vh;
}

.profil-container h1 {
  margin-bottom: 2rem;
}

/* En-tete */
.profil-header {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

.header-left h1 {
  /* font-size: 2.1rem; */
  font-weight: 700;
  margin: 0;
}

.entreprise-nom {
  margin: 0;
  font-size: 1.4rem;
  color: #6b7280;
}

.header-right {
  margin-left: auto;
  margin-top: 2rem;
}

/* Navigation par onglets */
.profil-tabs {
  margin-bottom: 2rem;
}

/* Contenu de l'onglet */
.profil-content {
  position: relative;
}

/* Overlay de sauvegarde */
.saving-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  z-index: 10;
  border-radius: 0.8rem;
  font-size: 1.2rem;
  color: #6b7280;
}

.saving-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e5e7eb;
  border-top-color: #da7027;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Etat de chargement */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #da7027;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 1rem;
}

.loading-container p {
  margin: 0;
  font-size: 1.2rem;
  color: #6b7280;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* État d'erreur */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  background: #fffdfc;
  border-radius: 0.8rem;
  box-shadow: 0 2px 8px rgba(44, 57, 72, 0.04);
}

.error-container h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.6rem;
  color: #dc2626;
}

.error-container p {
  margin: 0 0 1.5rem 0;
  font-size: 1.2rem;
  color: #6b7280;
}

/* Messages de visibilité - Style aligné avec Profil */
.visibility-notice {
  margin-bottom: 1.5rem;
}

.notice {
  display: flex;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
}

.notice-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.notice strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 1.2rem;
}

.notice p {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.5;
}

.notice-info {
  background: #dbeafe;
  border: 1px solid #93c5fd;
}

.notice-info strong,
.notice-info p {
  color: #1e40af;
}

.notice-warning {
  background: rgba(215, 217, 217, 0.2);
  border-left: 4px solid #da7027;
}

.notice-warning strong,
.notice-warning p {
  color: #2c3948;
}

/* Sections de formulaire */
.profil-prestataire-container .form-group {
  margin-bottom: 0.5rem;
}

.profil-prestataire-container .button-container {
  margin-top: 1.2rem;
  display: flex;
  justify-content: flex-end;
}

/* Style pour le contenu scrollable */
.section-content-scrollable {
  overflow-y: auto;
  height: 86%;
}

/* Responsive */
@media (max-width: 768px) {
  .profil-prestataire-container {
    padding: 1rem;
  }

  .profil-prestataire-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .header-left h1 {
    font-size: 1.8rem;
  }

  .header-right {
    width: 100%;
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .profil-prestataire-container {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/ProfilUnifie.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * CSS pour la page Profil unifiee (Accord Cadre + Prestataire Libre)\n * Design aligne avec le reste de l'application\n */\n\n.profil-container {\n  padding: 2rem;\n  background: #fafafa;\n  min-height: 100vh;\n}\n\n.profil-container h1 {\n  margin-bottom: 2rem;\n}\n\n/* En-tete */\n.profil-header {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.header-left h1 {\n  /* font-size: 2.1rem; */\n  font-weight: 700;\n  margin: 0;\n}\n\n.entreprise-nom {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #6b7280;\n}\n\n.header-right {\n  margin-left: auto;\n  margin-top: 2rem;\n}\n\n/* Navigation par onglets */\n.profil-tabs {\n  margin-bottom: 2rem;\n}\n\n/* Contenu de l'onglet */\n.profil-content {\n  position: relative;\n}\n\n/* Overlay de sauvegarde */\n.saving-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  z-index: 10;\n  border-radius: 0.8rem;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.saving-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #da7027;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* Etat de chargement */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #da7027;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.loading-container p {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* État d'erreur */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  background: #fffdfc;\n  border-radius: 0.8rem;\n  box-shadow: 0 2px 8px rgba(44, 57, 72, 0.04);\n}\n\n.error-container h2 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.6rem;\n  color: #dc2626;\n}\n\n.error-container p {\n  margin: 0 0 1.5rem 0;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n/* Messages de visibilité - Style aligné avec Profil */\n.visibility-notice {\n  margin-bottom: 1.5rem;\n}\n\n.notice {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-radius: 0.5rem;\n}\n\n.notice-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.notice strong {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 1.2rem;\n}\n\n.notice p {\n  margin: 0;\n  font-size: 1.1rem;\n  line-height: 1.5;\n}\n\n.notice-info {\n  background: #dbeafe;\n  border: 1px solid #93c5fd;\n}\n\n.notice-info strong,\n.notice-info p {\n  color: #1e40af;\n}\n\n.notice-warning {\n  background: rgba(215, 217, 217, 0.2);\n  border-left: 4px solid #da7027;\n}\n\n.notice-warning strong,\n.notice-warning p {\n  color: #2c3948;\n}\n\n/* Sections de formulaire */\n.profil-prestataire-container .form-group {\n  margin-bottom: 0.5rem;\n}\n\n.profil-prestataire-container .button-container {\n  margin-top: 1.2rem;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Style pour le contenu scrollable */\n.section-content-scrollable {\n  overflow-y: auto;\n  height: 86%;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .profil-prestataire-container {\n    padding: 1rem;\n  }\n\n  .profil-prestataire-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .header-left h1 {\n    font-size: 1.8rem;\n  }\n\n  .header-right {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .profil-prestataire-container {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
